import { Smartphone, MapPin, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CustomerProfileCard({ customer }) {
  const navigate = useNavigate();

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const isRetailerMobile =
    window.innerWidth < 640 && (authUser?.role === 5 || authUser?.role === 6);

  const initials =
    customer?.name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .slice(0, 2)
      .toUpperCase() || "U";

  return (
    <div
      onClick={() => navigate(`/customer-details/${customer.id}`)}
      className={`
        relative overflow-hidden active:scale-[0.98] transition-all duration-300
        ${
          isRetailerMobile
            ? "rounded-2xl bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
            : "rounded-xl bg-white shadow-md border border-slate-200"
        }
      `}
    >
      {/* HEADER */}
      <div
        className={`
          px-4 pt-4 pb-8 mb-4 text-white
          ${
            isRetailerMobile
              ? "bg-gradient-to-r from-blue-600/80 to-indigo-700/80 backdrop-blur-xl"
              : "bg-gradient-to-r from-blue-500 to-indigo-500"
          }
        `}
      >
        <div className="flex justify-between items-start">
          <p className="text-sm font-semibold tracking-wide">
            {customer.c_code}
          </p>

          <span
            className={`
              text-[11px] font-semibold px-3 py-1 rounded-full
              ${
                isRetailerMobile
                  ? "bg-white/20 border border-white/30"
                  : "bg-white/20"
              }
            `}
          >
            View →
          </span>
        </div>

        {/* AVATAR */}
        <div className="mt-5 flex justify-center">
          <div className="relative">
            <div
              className={`
                w-20 h-20 rounded-full overflow-hidden shadow-lg
                ${
                  isRetailerMobile
                    ? "bg-white/20 border border-white/30"
                    : "bg-white ring-4 ring-white"
                }
              `}
            >
              {customer?.devices?.link1 ? (
                <img
                  src={customer.devices.link1}
                  alt="Customer"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span
                  className={`
                    flex items-center justify-center h-full text-xl font-bold
                    ${
                      isRetailerMobile
                        ? "text-white"
                        : "text-blue-600"
                    }
                  `}
                >
                  {initials}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* BASIC INFO */}
      <div className="px-4 mt-2 text-center">
        <p
          className={`text-sm font-semibold ${
            isRetailerMobile ? "text-slate-900" : "text-slate-900"
          }`}
        >
          {customer.name || "-"}
        </p>

        <p className="text-xs text-slate-500 flex justify-center items-center gap-1 mt-1">
          <Smartphone size={12} />
          {customer.mobile || "-"}
        </p>
      </div>

      {/* STATS */}
      <div
        className={`
          mt-4 grid grid-cols-3 text-center
          ${
            isRetailerMobile
              ? "divide-x divide-white/20 border-t border-white/20"
              : "divide-x border-t border-slate-200"
          }
        `}
      >
        <Stat
          label="Devices"
          value={customer.devices?.length || 0}
          highlight
          isRetailerMobile={isRetailerMobile}
        />
        <Stat
          label="City"
          value={customer.city || "-"}
          isRetailerMobile={isRetailerMobile}
        />
        <Stat
          label="Pincode"
          value={customer.pincode || "-"}
          isRetailerMobile={isRetailerMobile}
        />
      </div>

      {/* DETAILS */}
      <div
        className={`
          px-4 py-3 space-y-2 text-xs
          ${
            isRetailerMobile
              ? "bg-white/5 backdrop-blur-xl border-t border-white/20"
              : "bg-slate-50"
          }
        `}
      >
        <Detail
          icon={<Mail size={14} />}
          label="Email"
          value={customer.email}
          isRetailerMobile={isRetailerMobile}
        />

        <Detail
          icon={<MapPin size={14} />}
          label="Location"
          value={`${customer.city || "-"}, ${customer.state || "-"}`}
          isRetailerMobile={isRetailerMobile}
        />
      </div>
    </div>
  );
}

/* ---------- Helpers ---------- */

function Stat({ label, value, highlight, isRetailerMobile }) {
  return (
    <div className="py-3">
      <p
        className={`text-sm font-bold ${
          highlight
            ? "text-blue-600"
            : isRetailerMobile
            ? "text-slate-900"
            : "text-slate-900"
        }`}
      >
        {value}
      </p>
      <p className="text-[11px] opacity-70">{label}</p>
    </div>
  );
}

function Detail({ icon, label, value, isRetailerMobile }) {
  return (
    <div className="flex items-start gap-3">
      <span
        className={`mt-0.5 ${
          isRetailerMobile ? "text-slate-400" : "text-slate-400"
        }`}
      >
        {icon}
      </span>

      <div className="flex-1">
        <p className="text-[11px] opacity-60">{label}</p>
        <p className="font-medium break-all leading-snug">
          {value || "-"}
        </p>
      </div>
    </div>
  );
}


// import { User, Smartphone, MapPin, Mail } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// export default function CustomerProfileCard({ customer }) {
//   const navigate = useNavigate();

//   const initials =
//     customer?.name
//       ?.split(" ")
//       .map((n) => n[0])
//       .join("")
//       .slice(0, 2)
//       .toUpperCase() || "U";

//   return (
//     <div
//       onClick={() => navigate(`/customer-details/${customer.id}`)}
//       className="relative rounded-xl bg-white shadow-md border border-slate-200 overflow-hidden active:scale-[0.99] transition"
//     >
//       {/* HEADER */}
//       <div className="bg-gradient-to-r from-blue-500 to-indigo-500 px-4 pt-4 pb-8 mb-4 text-white">
//         <div className="flex justify-between items-start">
//           <p className="text-sm font-semibold tracking-wide">
//             {customer.c_code}
//           </p>

//           <span className="text-[11px] font-semibold bg-white/20 px-3 py-1 rounded-full">
//             View →
//           </span>
//         </div>

//         {/* AVATAR */}
//         <div className="mt-5 flex justify-center">
//           <div className="relative">
//             <div className="w-20 h-20 rounded-full bg-white ring-4 ring-white shadow-lg overflow-hidden">
//                 {customer?.devices?.link1 ? (
//                     <img
//                     src={customer.devices.link1}
//                     alt="Customer"
//                     className="w-full h-full object-cover"
//                     />
//                 ) : (
//                     <span className="flex items-center justify-center h-full text-blue-600 text-xl font-bold">
//                     {initials}
//                     </span>
//                 )}
//                 </div>

//             {/* ONLINE DOT (optional visual) */}
//             {/* <span className="absolute bottom-1 right-1 h-3 w-3 rounded-full bg-emerald-500 border-2 border-white" /> */}
//           </div>
//         </div>
//       </div>

//       {/* BASIC INFO */}
//       <div className="px-4 mt-2 text-center">
//         <p className="text-sm font-semibold text-slate-900 ">
//           {customer.name || "-"}
//         </p>

//         <p className="text-xs text-slate-500 flex justify-center items-center gap-1 mt-1">
//           <Smartphone size={12} />
//           {customer.mobile || "-"}
//         </p>
//       </div>

//       {/* STATS */}
//       <div className="mt-4 grid grid-cols-3 divide-x border-t border-slate-200 text-center">
//         <Stat
//           label="Devices"
//           value={customer.devices?.length || 0}
//           highlight
//         />
//         <Stat
//           label="City"
//           value={customer.city || "-"}
//         />
//         <Stat
//           label="Pincode"
//           value={customer.pincode || "-"}
//         />
//       </div>

//       {/* DETAILS */}
//       <div className="px-4 py-3 space-y-2 text-xs text-slate-700 bg-slate-50">
//         <Detail
//           icon={<Mail size={14} />}
//           label="Email"
//           value={customer.email}
//         />

//         <Detail
//           icon={<MapPin size={14} />}
//           label="Location"
//           value={`${customer.city || "-"}, ${customer.state || "-"}`}
//         />
//       </div>
//     </div>
//   );
// }

// /* ---------- Helpers ---------- */

// function Stat({ label, value, highlight = false }) {
//   return (
//     <div className="py-3">
//       <p
//         className={`text-sm font-bold ${
//           highlight ? "text-blue-600" : "text-slate-900"
//         }`}
//       >
//         {value}
//       </p>
//       <p className="text-[11px] text-slate-500">
//         {label}
//       </p>
//     </div>
//   );
// }

// function Detail({ icon, label, value }) {
//   return (
//     <div className="flex items-start gap-3">
//       <span className="text-slate-400 mt-0.5">
//         {icon}
//       </span>

//       <div className="flex-1">
//         <p className="text-[11px] text-slate-400">
//           {label}
//         </p>
//         <p className="font-medium break-all leading-snug">
//           {value || "-"}
//         </p>
//       </div>
//     </div>
//   );
// }

